import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  if (!values.carTripImage1 || !values.carTripImage2) {
    showToaster({ messageId: 'blockSettingsFailed', toasterType: 'error' })
    return;
  }

  const carTripTitle2Array = values.carTripDetails2?.map(item => ({
    language: item.language,
    title: item.title || ''
  }));

  const carTripContent2Array = values.carTripDetails2?.map(item => ({
    language: item.language,
    content: item.content || ''
  }));

  const carTripTitle3Array = values.carTripDetails3?.map(item => ({
    language: item.language,
    title: item.title || ''
  }));

  const carTripContent3Array = values.carTripDetails3?.map(item => ({
    language: item.language,
    content: item.content || ''
  }));

  const mutation = `
    mutation (
      $carTripTitle1: String,
      $carTripTitle2: String,
      $carTripContent2: String,
      $carTripTitle3: String,
      $carTripContent3: String,
      $dynamicCarTripTitle1: String,
      $dynamicCarTripTitle2: String,
      $dynamicCarTripContent2: String,
      $dynamicCarTripTitle3: String,
      $dynamicCarTripContent3: String
    ) {
      updateStaticInfoBlock (
        carTripTitle1: $carTripTitle1,
        carTripTitle2: $carTripTitle2,
        carTripContent2: $carTripContent2,
        carTripTitle3: $carTripTitle3,
        carTripContent3: $carTripContent3,
        dynamicCarTripTitle1: $dynamicCarTripTitle1,
        dynamicCarTripTitle2: $dynamicCarTripTitle2,
        dynamicCarTripContent2: $dynamicCarTripContent2,
        dynamicCarTripTitle3: $dynamicCarTripTitle3,
        dynamicCarTripContent3: $dynamicCarTripContent3
      ) {
        status
      }
    }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: mutation,
      variables: {
        carTripTitle1: values.carTripTitle1?.[0]?.title,
        carTripTitle2: carTripTitle2Array?.[0]?.title,
        carTripContent2: carTripContent2Array?.[0]?.content,
        carTripTitle3: carTripTitle3Array?.[0]?.title,
        carTripContent3: carTripContent3Array?.[0]?.content,

        dynamicCarTripTitle1: JSON.stringify(values.carTripTitle1),
        dynamicCarTripTitle2: JSON.stringify(carTripTitle2Array),
        dynamicCarTripContent2: JSON.stringify(carTripContent2Array),
        dynamicCarTripTitle3: JSON.stringify(carTripTitle3Array),
        dynamicCarTripContent3: JSON.stringify(carTripContent3Array),
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateStaticInfoBlock.status === "success") {
    showToaster({ messageId: 'blockSettingsUpdate', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'blockSettingsFailed', toasterType: 'error' })
  }
}

export default submit;